import { memo } from 'react'

import SubmittedIdeas from './SubmittedIdeas'

const SubmittedIdeasComponent = memo(SubmittedIdeas)

export default SubmittedIdeasComponent
